import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as mapUtils from '../assets/map-utils'

Vue.use(Vuex)

export default () => {
  return new Vuex.Store({
    state: {
      application: window.APPLICATION,
      dataset: null,
      loading: true,
      parcel: null,
      features: [],
    },
    getters: {
      tileserverUrl (state) {
        return state.application.apiUrl + '/remote-services/tileserver-koumoul/proxy'
      },
      datasetUrl (state) {
        return state.application.configuration &&
          state.application.configuration.datasets &&
          state.application.configuration.datasets[0] &&
          state.application.configuration.datasets[0].href
      },
      parcelleIdField (state) {
        return state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://dbpedia.org/ontology/codeLandRegistry')
      },
      linkField (state) {
        return state.dataset && state.dataset.schema.find(f => f['x-refersTo'] === 'https://schema.org/WebPage')
      },
      attachmentField (state) {
        return state.dataset && state.dataset.schema.find(f => f['x-refersTo'] === 'http://schema.org/DigitalDocument')
      },
      config (state) { return state.application.configuration },
      defaultColor (state) {
        return state.application.configuration.defaultColor || '#828282'
      },
      dateField (state) {
        return state.dataset && state.dataset.schema.find(field => field['x-refersTo'] === 'http://schema.org/Date')
      },
      legend (state, getters) {
        if (!state.dataset) return []
        if (getters.config && getters.config.colorField) {
          const colorField = state.dataset.schema.find(f => f.key === getters.config.colorField)
          if (getters.config.colors) return getters.config.colors.map(c => [c.value, c.color])
          else return colorField.enum.map((val, i) => [val, mapUtils.colors[i]])
        } else {
          return [['*', getters.defaultColor]]
        }
      },
    },
    mutations: {
      setAny (state, params) {
        Object.assign(state, params)
      },
    },
    actions: {
      async init ({ state, commit, dispatch, getters }) {
        if (getters.datasetUrl) {
          try {
            const { data } = await axios.get(getters.datasetUrl)
            commit('setAny', { dataset: data })
            const qParams = new URLSearchParams(window.location.search)
            if (qParams.get('selected')) {
              const ids = qParams.get('selected').split(',')
              const select = [].concat(getters.config.tooltip)
              if (getters.linkField) select.push(getters.linkField.key)
              if (getters.config.colorField) select.push(getters.config.colorField)
              const params = {
                size: 1000,
                select: select.join(','),
                qs: `${getters.parcelleIdField.key}:(${ids.join(' OR ')})`,
              }
              if (getters.dateField) params.sort = getters.dateField.key

              const { data } = await axios.get(`${getters.datasetUrl}/lines`, { params })
              commit('setAny', { features: data.results })
            }
          } catch (err) {
            dispatch('setError', (err.response && err.response.data) || err.message)
          }
        }
      },
      async setError ({ state }, error) {
        try {
          axios.post(state.application.href + '/error', { message: error.message || error })
        } catch (err) {
          console.log('Failed to report error', err)
        }
      },
    },
  })
}
